/**
 * Ordenação client-side de tabelas markdown Orya.
 */

function stripMarkdownCellText(value) {
  return String(value ?? '')
    .replace(/\*\*/g, '')
    .trim();
}

function parseSortNumber(raw) {
  const s = stripMarkdownCellText(raw);
  if (!s || s === '—' || s === '-') return null;
  if (!/^-?[\d.,]+$/.test(s)) return null;

  const ptBr = /^-?\d{1,3}(?:\.\d{3})+(?:,\d+)?$|^-?\d+,\d+$/.test(s);
  let norm = s;
  const hasComma = norm.includes(',');
  const hasDot = norm.includes('.');

  if (ptBr || (hasComma && hasDot)) {
    norm = norm.replace(/\./g, '').replace(',', '.');
  } else if (hasComma) {
    norm = norm.replace(',', '.');
  } else if (hasDot) {
    const [, frac] = norm.split('.');
    if (!frac || frac.length > 2) norm = norm.replace(/\./g, '');
  }

  const n = Number(norm);
  return Number.isFinite(n) ? n : null;
}

function parseSortDate(raw) {
  const s = stripMarkdownCellText(raw);
  const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(s);
  if (!m) return null;
  const ts = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1])).getTime();
  return Number.isNaN(ts) ? null : ts;
}

export function compareOryaTableCells(a, b) {
  const sa = stripMarkdownCellText(a);
  const sb = stripMarkdownCellText(b);
  if (!sa && !sb) return 0;
  if (!sa) return 1;
  if (!sb) return -1;

  const na = parseSortNumber(sa);
  const nb = parseSortNumber(sb);
  if (na != null && nb != null) return na - nb;
  if (na != null) return -1;
  if (nb != null) return 1;

  const da = parseSortDate(sa);
  const db = parseSortDate(sb);
  if (da != null && db != null) return da - db;
  if (da != null) return -1;
  if (db != null) return 1;

  return sa.localeCompare(sb, 'pt-BR', { numeric: true, sensitivity: 'base' });
}

export function sortOryaTableRows(rows, columnIndex, direction = 'asc') {
  if (!Array.isArray(rows) || columnIndex == null || columnIndex < 0) return rows;
  const mult = direction === 'desc' ? -1 : 1;
  return [...rows].sort((rowA, rowB) => {
    const a = rowA?.[columnIndex];
    const b = rowB?.[columnIndex];
    return compareOryaTableCells(a, b) * mult;
  });
}
